import { Event } from '@adminModels';
import { CreateEventData, EventsQueryParams, PaginatedResponse, UpdateEventData } from '@adminServices';
import { createAction, props } from '@ngrx/store';

export const ADMIN_EVENTS_ID = '[Events admin]';

export const loadEvents = createAction(
  ADMIN_EVENTS_ID + ' Load Events',
  props<{ params?: EventsQueryParams }>(),
);

export const loadEventsSuccess = createAction(
  ADMIN_EVENTS_ID + ' Load Events Success',
  props<{ response: PaginatedResponse<Event> }>(),
);

export const loadEventsFailure = createAction(
  ADMIN_EVENTS_ID + ' Load Events Failure',
  props<{ error: string }>(),
);

export const loadEventById = createAction(
  ADMIN_EVENTS_ID + ' Load Event By Id',
  props<{ id: string }>(),
);

export const loadEventByIdSuccess = createAction(
  ADMIN_EVENTS_ID + ' Load Event By Id Success',
  props<{ event: Event }>(),
);

export const loadEventByIdFailure = createAction(
  ADMIN_EVENTS_ID + ' Load Event By Id Failure',
  props<{ error: string }>(),
);

export const createEvent = createAction(
  ADMIN_EVENTS_ID + ' Create Event',
  props<{ eventData: CreateEventData }>(),
);

export const createEventSuccess = createAction(
  ADMIN_EVENTS_ID + ' Create Event Success',
  props<{ event: Event }>(),
);

export const createEventFailure = createAction(
  ADMIN_EVENTS_ID + ' Create Event Failure',
  props<{ error: string }>(),
);

export const updateEvent = createAction(
  ADMIN_EVENTS_ID + ' Update Event',
  props<{ id: string; eventData: UpdateEventData }>(),
);

export const updateEventSuccess = createAction(
  ADMIN_EVENTS_ID + ' Update Event Success',
  props<{ event: Event }>(),
);

export const updateEventFailure = createAction(
  ADMIN_EVENTS_ID + ' Update Event Failure',
  props<{ error: string }>(),
);

export const deleteEvent = createAction(
  ADMIN_EVENTS_ID + ' Delete Event',
  props<{ id: string }>(),
);

export const deleteEventSuccess = createAction(
  ADMIN_EVENTS_ID + ' Delete Event Success',
  props<{ id: string }>(),
);

export const deleteEventFailure = createAction(
  ADMIN_EVENTS_ID + ' Delete Event Failure',
  props<{ error: string }>(),
);

export const uploadTitleImage = createAction(
  ADMIN_EVENTS_ID + ' Upload Title Image',
  props<{ id: string; file: File }>(),
);

export const uploadTitleImageSuccess = createAction(
  ADMIN_EVENTS_ID + ' Upload Title Image Success',
  props<{ event: Event }>(),
);

export const uploadTitleImageFailure = createAction(
  ADMIN_EVENTS_ID + ' Upload Title Image Failure',
  props<{ error: string }>(),
);

export const uploadThumbnail = createAction(
  ADMIN_EVENTS_ID + ' Upload Thumbnail',
  props<{ id: string; file: File }>(),
);

export const uploadThumbnailSuccess = createAction(
  ADMIN_EVENTS_ID + ' Upload Thumbnail Success',
  props<{ event: Event }>(),
);

export const uploadThumbnailFailure = createAction(
  ADMIN_EVENTS_ID + ' Upload Thumbnail Failure',
  props<{ error: string }>(),
);

export const deleteTitleImage = createAction(
  ADMIN_EVENTS_ID + ' Delete Title Image',
  props<{ id: string }>(),
);

export const deleteTitleImageSuccess = createAction(
  ADMIN_EVENTS_ID + ' Delete Title Image Success',
  props<{ event: Event }>(),
);

export const deleteTitleImageFailure = createAction(
  ADMIN_EVENTS_ID + ' Delete Title Image Failure',
  props<{ error: string }>(),
);

export const deleteThumbnail = createAction(
  ADMIN_EVENTS_ID + ' Delete Thumbnail',
  props<{ id: string }>(),
);

export const deleteThumbnailSuccess = createAction(
  ADMIN_EVENTS_ID + ' Delete Thumbnail Success',
  props<{ event: Event }>(),
);

export const deleteThumbnailFailure = createAction(
  ADMIN_EVENTS_ID + ' Delete Thumbnail Failure',
  props<{ error: string }>(),
);

export const selectEvent = createAction(
  ADMIN_EVENTS_ID + ' Select Event',
  props<{ event: Event | null }>(),
);

